import { useEffect } from 'react';

const FALLBACK_REDIRECT = 'https://www.mytheresa.com/to/service/confirm';

// Hands the DOI token off to the EBS prospects API. The EBS endpoint redeems the token
// and returns a 302 to the redirectUrl the admin configured on the event (or its built-in
// success page if none). Using browser-level navigation rather than fetch lets the
// redirect happen natively. Falls back to the legacy Mytheresa confirmation page when
// either the token is missing or the API URL isn't configured.
function ConfirmEmail() {
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    const apiUrl = process.env.REACT_APP_BOOKING_API_URL;

    if (!token || !apiUrl) {
      console.error('Confirm flow misconfigured', { hasToken: !!token, hasApiUrl: !!apiUrl });
      window.location.replace(FALLBACK_REDIRECT);
      return;
    }

    window.location.replace(
      `${apiUrl.replace(/\/$/, '')}/prospects/confirm?token=${encodeURIComponent(token)}`
    );
  }, []);

  return null;
}

export default ConfirmEmail;
